var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.746 22V8.505H2.264V22h4.482ZM4.506 6.663c1.562 0 2.535-1.036 2.535-2.331C7.01 3.007 6.068 2 4.535 2S2 3.007 2 4.332c0 1.295.972 2.33 2.476 2.33h.03v.001ZM9.226 22h4.481v-7.536c0-.402.03-.806.148-1.094.323-.806 1.06-1.64 2.3-1.64 1.62 0 2.27 1.237 2.27 3.051V22h4.48v-7.738c0-4.145-2.21-6.073-5.159-6.073-2.417 0-3.479 1.352-4.068 2.273h.03V8.506H9.225c.059 1.265 0 13.494 0 13.494Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;